import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const fetchDailyMinimumPricingAction = {
    ...operations,
    ...selectors,
};

export {
    fetchDailyMinimumPricingAction,
};
export default {
    [namespace]: reducer,
};
